import { ROUTES } from '@ab-core/functions';
import type { LineItemProduct } from '@ab-core/graphql/dist';
import { useProductsAvailabilitiesWithChannel } from '@ab-core/hooks-v2';
import getActiveCart from '@ab-core/hooks/cartNew/activeCart/useActiveCart';
import type { DefaultScalableProductCardProps } from '../cardLayout';
import { fallBackPosition, fallBackQuantityUnit, fallBackSalesUnit } from './fallBackStates';

export const useMappedLineItemToScalableProductPremium = (
    products?: Array<LineItemProduct>
): Array<DefaultScalableProductCardProps['product']> => {
    const { activeCart } = getActiveCart();

    const skus: Array<string> = [];
    products?.map((product) => skus.push(product.sku || ''));

    const { productsAvailabilitiesWithChannel } = useProductsAvailabilitiesWithChannel(
        {
            skus,
            cartId: activeCart?.id
        },
        !activeCart
    );
    const productList: Array<DefaultScalableProductCardProps['product']> = [];

    products?.map((product) => {
        const link = `${ROUTES.PRAEMIEN_SHOP_DETAIL}/${product.sku}`;

        const productAvailability = productsAvailabilitiesWithChannel?.find(
            (available) => available.sku === product.sku
        );

        const customDeliveryInfo =
            (productAvailability?.aggregatedMainChannelQuantity || 0) < 1
                ? 'Diese Prämie wird zeitnah für Sie beschafft.'
                : '';

        const maxQuantity = product.isLimitedQuantity ? productAvailability?.aggregatedMainChannelQuantity : undefined;

        productList.push({
            lineItemId: product.id,
            defaultQuantity: product.quantity || product.salesUnit || fallBackSalesUnit,
            defaultPositionText: product.positionText || '',
            sku: product.sku || '',
            information: { reach: product.reachInfo },
            tags: {
                product: {
                    isAbakus: product.bonus?.isAbakus,
                    isAbakusPlus: product.bonus?.isAbakusPlus,
                    topProduct: product.bonus?.isTopProduct,
                    isTecselect: product.bonus?.isTecselect,
                    isPromotion: product.bonus?.isPromotion,
                    scoreCardIndex: product.scoreCardIndex
                }
            },
            ids: {
                articleNumber: product.sku,
                ean: product.ean,
                customerArticleNumber: product.customerArticleNumber
            },
            image: {
                link,
                imgSrc: product.thumbnail || '',
                sku: product.sku,
                position: Number(product.position) || fallBackPosition
            },
            name: {
                link,
                text: product.productName,
                sku: product.sku,
                position: Number(product.position) || fallBackPosition
            },
            additionalLinks: {
                sku: product.sku,
                hasAccessories: product.hasAccessories,
                hasAlternatives: product.hasAlternatives
            },
            prices: {
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                salesUnit: product.salesUnit || fallBackSalesUnit
            },
            availability: {
                availability: productAvailability,
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                customDeliveryInfo
            },
            order: {
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                salesUnit: product.salesUnit || fallBackSalesUnit,
                sku: product.sku || '',
                isUnqualifiedContractProduct: product.isUnqualifiedContractProduct || false,
                chargeNr: product.chargeNr,
                packagingSize: product?.packagingSize || '',
                position: Number(product.position) || fallBackPosition,
                maxQuantity
            },
            comparison: {
                sku: product.sku,
                title: product.productName,
                imageSrc: product.thumbnail || ''
            }
        });
    });

    return productList;
};
